import { Api } from './axios-config';

export interface PlanFeatureView {
  code: string;
  name: string;
  description?: string;
  category?: string;
  enabled: boolean;
}

export interface PlanLimitView {
  key: string;
  value: number;
}

export interface SubscriptionView {
  id: number;
  businessId: number;
  businessName: string;
  subscriptionPlanId: number;
  planName: string;
  planSlug: string;
  status: string;
  billingCycle: string;
  startsAt: string;
  expiresAt?: string;
  trialEndsAt?: string;
  isTrialing: boolean;
  monthlyPrice: number;
  yearlyPrice: number;
  features: PlanFeatureView[];
  limits: PlanLimitView[];
}

export interface PlanListView {
  id: number;
  name: string;
  slug: string;
  description?: string;
  monthlyPrice: number;
  yearlyPrice: number;
  yearlyDiscountPercentage?: number;
  isPopular: boolean;
  displayOrder: number;
  features: PlanFeatureView[];
  limits: PlanLimitView[];
}

const getPlans = async (): Promise<PlanListView[]> => {
  const { data } = await Api.get<PlanListView[]>(
    '/api/plans'
  );
  return data;
};

const getMySubscription = async (): Promise<SubscriptionView | null> => {
  try {
    const { data } = await Api.get<SubscriptionView>('/api/subscription/my');
    return data;
  } catch {
    return null;
  }
};

const createTrial = async (businessId: number, planSlug: string): Promise<void> => {
  await Api.post(`/api/subscription/create-trial/${businessId}?plan=${planSlug}`);
};

export const subscriptionService = {
  getPlans,
  getMySubscription,
  createTrial,
};
